'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuoteRefs = exports.getPrices = exports.quoting = exports.hasQuoted = exports.getQuoteOptions = exports.getQuotes = exports.getQuoteInfo = undefined;
var _reselect = require('reselect');
var _selectors = require('@marmalade/ldi/lib/quote/selectors');
var _constants = require('./constants');
var getQuoteInfo = exports.getQuoteInfo = function getQuoteInfo(state) {
  return state[_constants.NAME];
};
var getQuotes = exports.getQuotes = function getQuotes(state) {
  return state[_constants.NAME].quotes;
};
var getQuoteOptions = exports.getQuoteOptions = function getQuoteOptions(state) {
  return state[_constants.NAME].params;
};
var hasQuoted = exports.hasQuoted = function hasQuoted(state) {
  return !!getQuoteInfo(state).quoted;
};
var quoting = exports.quoting = function quoting(state) {
  return getQuoteInfo(state).fetching;
};
var getPrices = exports.getPrices = (0, _reselect.createSelector)(getQuotes, function (_ref) {
  var ldi = _ref.ldi,
    ndi = _ref.ndi,
    fdi = _ref.fdi,
    sdi = _ref.sdi;
  return {
    ldi: typeof ldi !== 'undefined' ? (0, _selectors.calculatePrices)(ldi.quotes) : undefined,
    fdi: typeof fdi !== 'undefined' ? fdi.quotes : undefined,
    sdi: typeof sdi !== 'undefined' ? sdi.quotes : undefined,
    ndi: typeof ndi !== 'undefined' ? ndi.quotes : undefined,
    ndiPayg: typeof ndi !== 'undefined' ? ndi.payg : undefined
  };
});
var getQuoteRefs = exports.getQuoteRefs = (0, _reselect.createSelector)(getQuotes, function (_ref2) {
  var ldi = _ref2.ldi,
    ndi = _ref2.ndi,
    fdi = _ref2.fdi,
    sdi = _ref2.sdi;
  return {
    ldi: typeof ldi !== 'undefined' ? ldi.quoteRef.toString() : undefined,
    fdi: typeof fdi !== 'undefined' ? fdi.quoteRef : undefined,
    sdi: typeof sdi !== 'undefined' ? sdi.quoteRef : undefined,
    ndi: typeof ndi !== 'undefined' ? ndi.quoteRef : undefined
  };
});